// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2tZri","checkboxCol":"Table_checkboxCol__23Spb","emailCol":"Table_emailCol__2sy9v","actionCol":"Table_actionCol__2wcrj"};